"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFooter = void 0;
const react_1 = __importDefault(require("react"));
const _1 = require(".");
require("./index.scss");
const TableFooter = (props) => {
    const { actionsSlot, paginationSlot, } = props;
    return (react_1.default.createElement("div", { className: `${_1.className}__footer` },
        actionsSlot && (react_1.default.createElement("div", { className: `${_1.className}__actions` }, actionsSlot)),
        paginationSlot && (react_1.default.createElement("div", { className: `${_1.className}__pagination` }, paginationSlot))));
};
exports.TableFooter = TableFooter;
//# sourceMappingURL=TableFooter.js.map